import { ComponentCompareAspect } from './component-compare.aspect';

export type { ComponentCompareMain } from './component-compare.main.runtime';
export type { ComponentCompareUI, ComponentCompareNavSlot } from './component-compare.ui.runtime';
export { ComponentCompareAspect };
export default ComponentCompareAspect;
